// firebase.js
import { initializeApp } from "firebase/app";
import { 
  initializeAuth, 
  browserLocalPersistence, 
  browserPopupRedirectResolver, 
  indexedDBLocalPersistence 
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBjz6xtBLvwpDFa2SY1R2HJgV7PzDZcqIg",
  authDomain: "dpsinnov.com",
  databaseURL: "https://fir-support-testproj-default-rtdb.firebaseio.com",
  projectId: "fir-support-testproj",
  storageBucket: "fir-support-testproj.appspot.com",
  messagingSenderId: "769244627687",
  appId: "1:769244627687:web:9b9f4a5655f16ff578d842"
};

const app = initializeApp(firebaseConfig);

// Initialize Auth once and export it
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  popupRedirectResolver: browserPopupRedirectResolver
});